(function () {
  const SWIPER_TIMEOUT = 8000;

  function numberFromAttribute(element, name, fallback) {
    const value = Number(element.getAttribute(name));

    return Number.isFinite(value) ? value : fallback;
  }

  function booleanFromAttribute(element, name) {
    return element.getAttribute(name) === 'true';
  }

  function waitForSwiper(callback, startedAt = Date.now()) {
    if (window.Swiper) {
      callback();
      return;
    }

    if (Date.now() - startedAt > SWIPER_TIMEOUT) return;

    window.setTimeout(() => waitForSwiper(callback, startedAt), 50);
  }

  function initCarousel(carousel) {
    if (!carousel || carousel.dataset.carouselSwiperInitialized === 'true') return;

    const viewport = carousel.querySelector('.carousel-swiper__viewport');
    const wrapper = carousel.querySelector('.carousel-swiper__wrapper');
    const slides = wrapper ? Array.from(wrapper.children) : [];

    if (!viewport || !wrapper || !slides.length) return;

    slides.forEach((slide) => {
      slide.classList.add('swiper-slide');
      slide.removeAttribute('aria-hidden');
    });

    const columns = numberFromAttribute(carousel, 'data-columns', 3);
    const mobileColumns = numberFromAttribute(carousel, 'data-mobile-columns', 1);
    const gap = numberFromAttribute(carousel, 'data-gap', 16);
    const autoplaySpeed = numberFromAttribute(carousel, 'data-autoplay-speed', 0);
    const loop = booleanFromAttribute(carousel, 'data-loop') && slides.length > columns;
    const showPagination = carousel.querySelector('.carousel-swiper__pagination');
    const prevButton = carousel.querySelector('.carousel-swiper__button--prev');
    const nextButton = carousel.querySelector('.carousel-swiper__button--next');

    carousel.dataset.carouselSwiperInitialized = 'true';

    carousel.carouselSwiper = new window.Swiper(viewport, {
      wrapperClass: 'carousel-swiper__wrapper',
      slideClass: 'swiper-slide',
      slidesPerView: mobileColumns,
      spaceBetween: gap,
      loop,
      watchOverflow: true,
      autoplay:
        autoplaySpeed > 0
          ? {
              delay: autoplaySpeed * 1000,
              disableOnInteraction: false,
              pauseOnMouseEnter: true,
            }
          : false,
      pagination: showPagination
        ? {
            el: showPagination,
            clickable: true,
          }
        : false,
      navigation:
        prevButton && nextButton
          ? {
              prevEl: prevButton,
              nextEl: nextButton,
            }
          : false,
      breakpoints: {
        750: {
          slidesPerView: columns,
          spaceBetween: gap,
        },
      },
    });
  }

  function initCarousels(root = document) {
    waitForSwiper(() => {
      root.querySelectorAll('[data-carousel-swiper]').forEach(initCarousel);
    });
  }

  document.addEventListener('DOMContentLoaded', () => initCarousels());
  document.addEventListener('shopify:section:load', (event) => initCarousels(event.target));
  document.addEventListener('shopify:block:select', (event) => {
    const carousel = event.target.closest?.('[data-carousel-swiper]');

    if (carousel?.carouselSwiper) {
      carousel.carouselSwiper.update();
    }
  });
})();
